import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("polygon", {
		className: "plan2plate-icon",
		points: "12 2.78 14.94 8.73 21.5 9.68 16.75 14.31 17.87 20.85 12 17.77 6.13 20.85 7.25 14.31 2.5 9.68 9.06 8.73 12 2.78"
	})]
});
const ForwardRef = forwardRef(SvgStar);
export default ForwardRef;
